// Shared helpers for per-page SEO meta-tags (vue-meta metaInfo()).

// Fallback Open Graph image used when a page has no own image yet.
// Replaced by a branded 1200x630 banner in SEO item #6.
export const OG_DEFAULT_IMAGE =
  'https://www.inviplay.nl/img/icons/android-chrome-512x512.png'

// Trim a string to `max` characters, adding an ellipsis when cut.
// Used to keep meta descriptions within the ~160 char search-snippet limit.
export const truncate = (str, max) =>
  str && str.length > max ? `${str.slice(0, max - 1).trimEnd()}…` : str
